import React, {useState} from 'react';
import Image from '../icons/Bottom_Image.png'
import Activity from './Activity';
import Mood from './Mood';

// The image fills the banner as a background and is cropped to the banner's height
// (.bottom_banner in App.css). Cropping removes the corners rounded in the PNG, so the
// radius is set here.
const imageStyle = {
    objectFit: 'cover',
    borderRadius: 'clamp(0.4rem, 1.6vw, 1rem)',
}

function BottomComponent(props) {

    return (
        <div className='w-100 d-flex justify-content-center'>
            <div className='p-2 p-lg-5' style={{width:'97%'}}>
                <div className='bottom_banner position-relative d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-between gap-1 gap-md-3 px-3 px-md-4 px-xl-5 py-1 py-md-2'>
                    <img
                        className='position-absolute top-0 start-0 w-100 h-100'
                        style={imageStyle}
                        src = {Image}
                        alt = ''/>
                    <div className='position-relative text-center text-md-start'>
                        <div className = 'text-white fw-bold bottom_text'>
                            We will advise you what to see
                        </div>
                        <div className = 'text-white fw-bold bottom_text'>
                            and listen to when you want...
                        </div>
                    </div>
                    <div className='position-relative d-flex col-10 col-md-5 col-xl-4' style={{gap:'0.5rem'}} >
                        <Activity
                            user = {props.user}
                            setFilterList={props.setFilterList}
                            setActiveComponent={props.setActiveComponent}
                        />
                        <Mood
                            user = {props.user}
                            setFilterList={props.setFilterList}
                            setActiveComponent={props.setActiveComponent}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BottomComponent;
